interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  actionText?: string;
  actionTo?: string;
}

import { Link } from "react-router-dom";

export default function SectionHeading({
  eyebrow,
  title,
  subtitle,
  actionText,
  actionTo,
}: SectionHeadingProps) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3 mb-6 md:mb-8">
      <div>
        {eyebrow && (
          <span className="text-xs font-medium tracking-[0.2em] text-primary-600 uppercase">
            {eyebrow}
          </span>
        )}
        <h2 className="font-heading text-xl md:text-3xl font-semibold text-foreground-950 mt-1.5">
          {title}
        </h2>
        {subtitle && <p className="text-sm text-foreground-600 mt-2 max-w-2xl">{subtitle}</p>}
      </div>
      {actionText && actionTo && (
        <Link
          to={actionTo}
          className="inline-flex items-center gap-1 text-sm text-primary-700 hover:text-primary-800 whitespace-nowrap cursor-pointer shrink-0"
        >
          {actionText}
          <i className="ri-arrow-right-line"></i>
        </Link>
      )}
    </div>
  );
}